module.exports = __webpack_public_path__ + "media/images/identification-documents/my_number-44216c74f30decb3fd2753c47e6be1fd.png";